import React, { Component } from "react";
import PropTypes from "prop-types";
import filterSvg from "../assets/filter.svg";
import SearchBox from "./searchBox";
import NoDataFound from "./NoDataFound";
import { scrollToPosition } from "../helper";
import Filter from "../assets/user-filter.svg";
import IssueSummarySearchModal from "../container/mis/IssueSummarySearchModal";
import ProjectSummarySearchModal from "../container/mis/ProjectSummarySearchModal";
// import { Modal } from "react-bootstrap";
import { activeReport } from "../actions/mis.action";
class FilterComponent extends Component {
  state = {
    showFilter: false,
    selected: null,
    searchList: [],
    inputData: "",
    openIssueFilterModal: false,
    openProjectFilterModal: false
    // openIssueSummaryModal: false
  };

  componentWillReceiveProps(nextProps, nextContext) {
    let { makeSelectedNull } = nextProps;

    if (makeSelectedNull) {
      this.setState({
        selected: null
      });
      scrollToPosition({ top: 0 });
    }
  }

  filterHandler = () => {
    const { showFilter } = this.state;
    this.setState({ showFilter: !showFilter, inputData: "" });
  };

  onClickFilter = elem => {
    const { getFilterId } = this.props;
    //check for reset All ID
    if (elem.id !== 0) {
      this.setState({ selected: elem.id });
    } else {
      this.setState({ selected: null });
    }
    this.filterHandler();
    getFilterId(elem.id, elem);
  };

  getInputValue = inputData => {
    const { filterList } = this.props;
    let groupList = [];
    filterList.forEach(group => {
      if (group.name.toLowerCase().includes(inputData.toLowerCase())) {
        groupList.push(group);
      }
    });
    this.setState({ searchList: groupList, inputData: inputData });
  };

  showIssueSummary = (openModal, previousFilterCount, currentFilterCount) => {
    const { openIssueFilterModal } = this.state;
    const { onOpenOfModal } = this.props;
    this.setState({
      openIssueFilterModal: !openIssueFilterModal
    });
    onOpenOfModal(
      openIssueFilterModal,
      previousFilterCount,
      currentFilterCount
    );
  };

  showProjectSummary = (openModal, previousFilterCount, currentFilterCount) => {
    const { openProjectFilterModal } = this.state;
    const { onOpenOfProjectSummaryModal } = this.props;
    this.setState({
      openProjectFilterModal: !openProjectFilterModal
    });
    onOpenOfProjectSummaryModal(
      openProjectFilterModal,
      previousFilterCount,
      currentFilterCount
    );
  };

  render() {
    const {
      showFilter,
      selected,
      searchList,
      inputData,
      openIssueFilterModal,
      openProjectFilterModal
      // openIssueSummaryModal
    } = this.state;
    const {
      filterList,
      isUserFilter,
      isFromMisSection,
      activeReport
      // onSelectedFilter
    } = this.props;
    let groupList = [];
    if (inputData) {
      groupList = searchList;
    } else {
      groupList = filterList;
    }
    return (
      <>
        {isFromMisSection ? (
          <>
            <div
              className={`dropdown field-sort ${showFilter ? "visible" : ""}`}
            />
            <div
              className={`dropdown-selected-value filter-img ${
                isUserFilter ? "filter-in-mis-section" : ""
              }`}
              onClick={
                activeReport === "FLAT_FILE"
                  ? this.showIssueSummary
                  : this.showProjectSummary
              }
            >
              <div>
                <span>
                  <img src={Filter} alt="Filter Icon" />
                </span>
              </div>
            </div>
            <>
              {activeReport === "FLAT_FILE" && openIssueFilterModal ? (
                <IssueSummarySearchModal
                  activeReport={activeReport}
                  onOpenOfModal={this.showIssueSummary}
                />
              ) : (
                openProjectFilterModal && (
                  <ProjectSummarySearchModal
                    onOpenOfModal={this.showProjectSummary}
                  />
                )
              )}
            </>
          </>
        ) : (
          <div className={`dropdown field-sort ${showFilter ? "visible" : ""}`}>
            <div
              className={`dropdown-overlay ${showFilter ? "visible" : ""}`}
              onClick={this.filterHandler}
            />
            <div
              className={`dropdown-selected-value filter-img ${
                isUserFilter ? "filters-in-user-tab" : ""
              }`}
              onClick={this.filterHandler}
            >
              {isUserFilter ? (
                <>
                  <div>
                    <span>
                      <img src={Filter} alt="Filter Icon" />
                    </span>
                  </div>
                </>
              ) : (
                <>
                  <img src={filterSvg} alt="Filter Icon" />
                  Filter
                </>
              )}
            </div>
            <div className="dropdown-option-list max-ht-300 nodal-officer-filter">
              <SearchBox
                searchPageType={"filterSearch"}
                getInputValue={this.getInputValue}
              />
              {groupList && groupList.length ? (
                groupList.map((elem, index) => {
                  return (
                    <div
                      className={
                        elem.id === selected
                          ? "active-filter"
                          : "filter-list-item"
                      }
                      key={index}
                      onClick={e => {
                        e.stopPropagation();
                        this.onClickFilter(elem);
                      }}
                    >
                      {elem.name}
                    </div>
                  );
                })
              ) : (
                <NoDataFound />
              )}
            </div>
          </div>
        )}
      </>
    );
  }
}

FilterComponent.propTypes = {
  filterList: PropTypes.array,
  getFilterId: PropTypes.func
};
FilterComponent.defaultProps = {
  filterList: [],
  getFilterId: () => {}
};

export default FilterComponent;
